import React from "react";
import { MainCP } from "../../Components/marcas-ciudadanas/MainCP";

const ViewMarcasCiudadanas: React.FC = () => <MainCP/>
export default ViewMarcasCiudadanas;
